module.exports = __webpack_public_path__ + "img/webBrand--billy-dash.4f5c46f9.svg";